import { createBrowserRouter } from "react-router-dom";

import { AppShell } from "@/widgets/shell/AppShell";
import { AboutPage } from "@/pages/about/AboutPage";
import { LoginPage } from "@/pages/auth/LoginPage";
import { SignupPage } from "@/pages/auth/SignupPage";
import { AnalysisPage } from "@/pages/analysis/AnalysisPage";
import { BlogsPage } from "@/pages/blogs/BlogsPage";
import { DevlogPage } from "@/pages/devlog/DevlogPage";
import { GamesPage } from "@/pages/games/GamesPage";
import { HomePage } from "@/pages/home/HomePage";
import { LivestreamPage } from "@/pages/livestream/LivestreamPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PlayPage } from "@/pages/play/PlayPage";
import { PlaySessionPage } from "@/pages/play/PlaySessionPage";
import { EditProfilePage } from "@/pages/profile/EditProfilePage";
import { ProfilePage } from "@/pages/profile/ProfilePage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "analysis",
        element: <AnalysisPage />,
      },
      {
        path: "play",
        element: <PlayPage />,
      },
      {
        path: "play/session/:gameId",
        element: <PlaySessionPage />,
      },
      {
        path: "livestream",
        element: <LivestreamPage />,
      },
      {
        path: "games",
        element: <GamesPage />,
      },
      {
        path: "blogs",
        element: <BlogsPage />,
      },
      {
        path: "devlog",
        element: <DevlogPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "login/:authStatus",
        element: <LoginPage />,
      },
      {
        path: "signup",
        element: <SignupPage />,
      },
      {
        path: "@/:username",
        element: <ProfilePage />,
      },
      {
        path: "settings/profile",
        element: <EditProfilePage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
